import template from './template'
import instance from './instance'
import criteria from './criteria'
import surveyQuestion from './surveyQuestion'
import step from './step'
import statistics from './statistics'
import user from './user'

const merged = {...template, ...instance, ...criteria, ...surveyQuestion, ...step, ...statistics, ...user};

export default merged